@use 'src/global/variables' as var;

c-form-text {
    textarea {
      padding: 10px !important;
      margin:10px 0 10px 5%!important;
      width: 85% !important;
      border-radius: 10px !important;
      border-width: 2px;
    }

    label {
      margin-left: 5% !important;
    }

    .info {
      margin-left: 5% !important;
      margin-top: -20px !important;
      color: darkgrey;
      font-size: smaller !important;
    }
}